import * as React from 'react';
import { PropsRoute } from '@makemydeal/dr-activities-common';
import { default as SummaryLeadForm, ISummaryLeadFormProps as IRootProps } from './legacy/SummaryLeadForm/SummaryLeadForm';
import { getAllRoutes } from '../utils/routes';

const LeadFormRouting: React.FC<IRootProps> = (props) => {
    const routes = getAllRoutes();
    return (
        <>
            <PropsRoute {...props} path={routes.root} component={SummaryLeadForm} />
            <PropsRoute {...props} path={routes.leadForm} component={SummaryLeadForm} />
        </>
    );
};

export default LeadFormRouting;
